<template>
  <TransactionTemplate
    :getHeaderToolbar="getHeaderToolbar"
    :screenJson="getScreenJson"
    :headerScreenJson="getHeaderScreenJson"
    :setLoading="setLoading"
    :localDataGrid="true"
    :backButtonRoute="getBackButtonRoute"
    ref="bank-reconciliation"
    :data-model="getDataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :gcSundryTransactionPopupConfig="gcSundryTransactionPopupConfig"
    :warningSummary="warningSummary"
    :refreshDataGridProp="refreshDataGrid"
  />
</template>
<script>
import {
  BankAccountTransferTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/finance/bank-account-transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import TransactionTemplate from "../../templates/transaction.vue";
import CheckBox from "devextreme/ui/check_box";
import { BankAccountsServices } from "../../_services/api/finance/bankAccounts";
import { BankAccountTransactionServices } from "../../_services/api/finance/bank-account-transaction.service";
// import { CompanyService } from "../../_services/api/accounts/company.service";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { getDefaultUserSettings } from "../../_store/helpers";
export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      refreshDataGrid: false,
      reconciledRecordIndices: [],
      selectedGridItems: [],
      index: undefined,
      backRoute: "/bank-accounts",
      setLoading: false,
      reload: false,
      loaded: false,
      validationSummary: [],
      serverError: {},
      warningSummary: [],
      varianceStyle: undefined,
      dataModel: {
        SaveAs: "C",
        AccountName: undefined,
        BankAccountCode: undefined,
        Status: undefined,
        BSBNO: undefined,
        BankBranch: undefined,
        AccountNo: undefined,
        StatementDate: undefined,
        FXAccountBalance: undefined,
        BookBalance: undefined,
        FXBookBalance: undefined,
        FXStatementBalance: 0,
        FXOutstandingPaymentTotal: undefined,
        FXOutstandingReceiptTotal: undefined,
        FXOpeningBalance: undefined,
        FXReconciledReceipts: 0,
        FXReconciledPayments: 0,
        FXVarience: 0,
        LastReconciledDate: undefined,
        LastReconciledAmount: undefined,
        PaymentTotal: undefined,
        ReceiptTotal: undefined,
        ApiFXBookBalance: undefined,
        ApiFXOutstandingPaymentTotal: undefined,
        ApiFXOutstandingReceiptTotal: undefined,
        CompanyBank: undefined,
        ExportCode: undefined,
        ControlAccount: undefined,
        UserBank: undefined,
        AbaUserCode: undefined,
        OpenningBalanceFiscalPeriod: undefined,
        OpenningBalanceFiscalYear: undefined,
        CurrencyCode: "AUD",
        ExchangeRate: 0,
      },
      BankBookReconciliationStatementDate: undefined,
      BankBookReconciliationFXStatementBalance: undefined,
      model: {
        SaveAs: "C",
      },
      tradingPartners: [],
      gcSundryTransactionPopupVisible: false,
      reconciliationDetailRecords: [],
      BaseCurrency: "AUD",
    };
  },
  watch: {
    isLeaving(value) {
      if (!value) {
        this.index = GetIndexByTabName("Reconcile", this.baseView.id);
      }
    },
  },
  async created() {
    await this.initialized();
  },
  computed: {
    getIndex() {
      if (this.index !== undefined) {
        return this.index;
      } else return GetIndexByTabName("Reconcile", this.baseView.id);
    },
    // ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    // ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),
    getBackButtonRoute() {
      if (this.baseView.query.from === "bank-account-list") {
        return this.backRoute;
      }
      return `/bank-accounts-transaction/review/${this.baseView.id}`;
    },
    getDataModel() {
      return this.dataModel;
    },
    gcSundryTransactionPopupConfig() {
      return {
        gcPopupVisible: this.gcSundryTransactionPopupVisible,
        gcPopupCallBack: this.gcSundryTransactionPopupCallBack,
        init: () => {
          this.setrefreshDataGrid();
          this.initialized();
        },
        onSaveCallBack: undefined,
        parentScreen: "bank-account-reconciliation",
        dataModel: {
          AccountNo: this.dataModel.AccountNo,
          BSBNO: this.dataModel.BSBNO,
          BankAccountCode: this.baseView.id,
          FXCurrency: this.dataModel.CurrencyCode,
          ExchangeRate: this.dataModel.ExchangeRate,
        },
        formOptions: {
          gcLabelLocation: "left",
        },
        titleLines: [
          `${this.dataModel.AccountName}`,
          `${this.dataModel.BSBNO} ${this.dataModel.AccountNo}`,
        ],
      };
    },
    getHeaderToolbar() {
      return {
        headerToolbar: {
          screenName: "Bank Reconciliation ",
          pdf: false,
          audit: false,
          status: true,
          notes: false,
          edit: false,
          save: true,
          saveOptions: {
            items: [
              { text: "Save & Commit", id: "C", default: true },
              { text: "Save as Draft", id: "D" },
            ],

            keyExpr: "id",
            displayExpr: "text",
            dropDownOptions: {
              width: "150px",
            },
            saveKey: "SaveAs",
          },
          headerFormVisible: true,
          toolbarFormItems: [
            {
              screenField: "DateIn",
              dataField: "StatementDate",
              label: {
                text: "Statement Date",
              },
              editorOptions: {
                max: new Date(),
                width: 120,
              },
              allowUpdate: true,
              required: true,
            },
          ],
          saveCallback: this.saveBankReconciliation,
        },
      };
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          ScreenName: "Bank Reconciliation",
          // selectedIndex: GetIndexByTabName("Reconcile", this.baseView.id),
          selectedIndex: this.getIndex,
          tabs: BankAccountTransferTabs(this.baseView.id),
          title: {
            primary: {
              primary: {
                dataField: undefined,
                text: this.dataModel.AccountName,
              },
            },
            secondary: {
              dataField: "AccountNo",
              text: `${this.dataModel.BSBNO} `,
            },
          },

          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "FXBookBalance",
                      dataField: "FXBookBalance",
                      label: {
                        text: `GCORP Balance (${this.dataModel.CurrencyCode})`,
                      },
                      value: this.dataModel.FXBookBalance,
                      format: "Decimal-8-2",
                      allowUpdate: false,
                    },

                    {
                      screenField: "Total",
                      dataField: "FXOutstandingPaymentTotal",
                      label: {
                        text: `Add O/S Payments (${this.dataModel.CurrencyCode})`,
                      },
                      value: this.dataModel.FXOutstandingPaymentTotal,
                      allowUpdate: false,
                      format: "Decimal-8-2",
                    },
                    {
                      screenField: "Total",
                      dataField: "FXOutstandingReceiptTotal",
                      label: {
                        text: `Less O/S Receipts (${this.dataModel.CurrencyCode})`,
                      },
                      allowUpdate: false,
                      format: "Decimal-8-2",
                    },
                    {
                      screenField: "Total",
                      dataField: "FXAccountBalance",
                      label: {
                        text: `Account Balance (${this.dataModel.CurrencyCode})`,
                      },
                      allowUpdate: false,
                      format: "Decimal-8-2",
                    },
                  ],
                },

                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "Balance",
                      dataField: "FXStatementBalance",
                      label: {
                        text: `Statement Balance (${this.dataModel.CurrencyCode})`,
                      },
                      format: "Decimal-8-2",
                      allowUpdate: true,
                      editorOptions: {
                        onValueChanged: ({ value }) => {
                          this.calculateFXVarience(value);
                        },
                        min: -99999999.0,
                        max: 99999999.0,
                      },
                      validationRules: [
                        {
                          type: "range",
                          message:
                            "Statement Balance is not between 99999999.0 and 99999999.0",
                          min: -99999999.0,
                          max: 99999999.0,
                        },
                      ],
                    },
                    {
                      screenField: "Total",
                      dataField: "FXReconciledPayments",
                      label: {
                        text: `R/C Payments (${this.dataModel.CurrencyCode})`,
                      },
                      allowUpdate: false,
                    },
                    {
                      screenField: "Total",
                      dataField: "FXReconciledReceipts",
                      label: {
                        text: `R/C Receipts (${this.dataModel.CurrencyCode})`,
                      },
                      allowUpdate: false,
                    },
                    {
                      screenField: "Total",
                      dataField: "FXVarience",
                      label: {
                        text: `Variance (${this.dataModel.CurrencyCode})`,
                      },
                      editorOptions: {
                        onValueChanged: ({ value }) => {
                          if (value === 0) {
                            this.setVarianceStyle("bold-text");
                          } else {
                            this.setVarianceStyle("red-bold-text");
                          }
                        },
                      },
                      cssClass:
                        this.dataModel.FXVarience === 0
                          ? "bold-text"
                          : "red-bold-text",
                      allowUpdate: false,
                    },
                  ],
                },
              ],
            },
          ],
        },
      };
    },
    getScreenJson() {
      return {
        title: "Bank Accounts Transaction",
        endpoint: {
          primary: undefined,
        },

        gridData: {
          gridOptions: {
            dataSource: {
              // endpoint: "BankReconciliationDetail",
              // filter: [["Code", "=", `${this.baseView.id}`]],
              // serverPaging: true,
              allowGrouping: false,
              // postProcessCallback: this.bankReconciliationDetailPostProcess,
              items: this.reconciliationDetailRecords,
              localDataList: true,
            },
            noDataMessage: {
              "grouped-view": {
                addNew: {
                  class: "no-data",
                  title: "No Product Lines",
                  message: "",
                },
              },
              "flat-view": {
                addNew: {
                  class: "no-data",
                  title: "No Order Lines",
                  message: "",
                },
              },
            },
            options: {
              // pageSize: 1000,
              wordWrapEnabled: false,
              selectionMode: "multiple",
              // deferred: true,
              rowSelectCallBack: this.onRowSelectCallBack,
              onContentReadyCallBack: this.checkReconciledRecords,
              // keyboardNavigation: {
              //   key: [
              //     "RefNo",
              //     "TransactionNo",
              //     "TransactionMethod",
              //     "TransactionType",
              //   ],
              // },
              // selectionFilter: ['IsDraft', '=', 'YES']
            },
          },
          columns: [
            {
              screenField: "Date",
              gridDataField: "TransactionDate",
              filterDataField: "TransactionDate",
              width: ColumnWidth.Date.width,
              showInColumnChooser: true,
              sortOrder: "asc",
              filterIndex: 3,
              allowSorting: true,
              allowSearch: false,
            },
            {
              screenField: "TransactionType",
              dataField: "TransactionType",
              filterDataField: "TransactionType",
              width: ColumnWidth.TransactionType.width,
              allowSearch: true,
              filterIndex: 10,
              label: "Type ",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              dataSourceConfig: {
                data: [
                  "Supplier Payment",
                  "Customer Receipt",
                  "Sundry Payment",
                  "Sundry Receipt",
                ],
              },
            },

            {
              screenField: "TransactionMethod",
              dataField: "TransactionMethod",
              gridDataField: "TransactionMethod",
              width: ColumnWidth.TransactionMethod.width,
              exportFields: undefined,
              cellTemplate: undefined,
              label: "Method",
              allowSorting: true,
              allowSearch: true,
              showInColumnChooser: true,
              filterIndex: 11,
              filterLabel: "Method",
              filterDataField: "TransactionMethod",
            },
            {
              screenField: "TransactionCode",
              dataField: "ComputedTransactionNo",
              label: "Transaction Code",
              showInColumnChooser: false,
              visible: false,
              allowSearch: true,
              allowSorting: true,
            },
            {
              screenField: "TransactionCode",
              // type: "String",
              dataField: "TransactionNo",
              label: "Transaction",
              width: ColumnWidth.TransactionNo.width,
              minWidth: ColumnWidth.TransactionNo.minWidth,
              showInColumnChooser: true,
              visible: true,
              allowSearch: false,
              allowSorting: true,
              hyperlink: {
                url: "",
                dataField: "TransactionNo",
                gridUrlDataFields: ["TransactionType"],
                gridUrlConditions: [
                  {
                    values: [{ TransactionType: "Customer Receipt" }],
                    url: `customer-receipt/review/__ID__`,
                  },
                  {
                    values: [{ TransactionType: "Sundry Receipt" }],
                    url: `sundry-receipt/__ID__`,
                  },
                  {
                    values: [{ TransactionType: "Supplier Payment" }],
                    url: `supplier-payment/review/__ID__`,
                  },
                  {
                    values: [{ TransactionType: "Sundry Payment" }],
                    url: `sundry-payment/__ID__`,
                  },
                ],
                target: "_blank",
              },
              filterIndex: 2,
              filterDataField: "ComputedTransactionNo",
              filterLabel: "Transaction",
              filterEditorType: "dxTextBox",
              dataType: "string",
              type: "Text",
            },
            {
              screenField: "Reference",
              width: ColumnWidth.Username.width,
            },
            {
              screenField: "TradingPartner",
              dataField: "TransactionPartner",
              filterDataField: "TransactionPartner",
              exportFields: undefined,
              cellTemplate: undefined,
              label: "Partner",
              allowSorting: true,
              showInColumnChooser: true,
              allowSearch: true,
              filterIndex: 7,
              type: "Text",
            },
            {
              screenField: "DateCreated",
              dataField: "DateCreated",
              filterDataField: "DateCreated",
              allowSearch: false,
              filterIndex: 4,
              label: "Date Created",
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
            },
            {
              screenField: "CreatedBy",
              dataField: "CreatedBy",
              label: "Created By",
              width: ColumnWidth.Username.width,
              allowSorting: true,
              allowSearch: false,
              showInColumnChooser: true,
              visible: true,
            },
            {
              dataField: "ExchangeRate",
              label: "Exchange Rate",
              format: "Decimal-6-4",
              type: "Decimal",
              width: ColumnWidth.ExchangeRate.width,
              allowSorting: true,
              showInColumnChooser: true,
              visible: this.IsForeignCurrencyAccount,
              allowSearch: false,
            },
            {
              screenField: "FXAmount",
              dataField: "FXTransactionAmount",
              format: "Decimal-16-2",
              label: () => {
                return `FX Amount (${this.dataModel.CurrencyCode})`;
              },
              width: ColumnWidth.Amount.width,
              allowSorting: true,
              showInColumnChooser: true,
              visible: this.IsForeignCurrencyAccount,
              allowSearch: false,
              filterIndex: 1,
              type: "Integer",
              filterDataField: "FXTransactionAmount",
            },

            {
              screenField: "Total",
              dataField: "TransactionAmount",
              format: "Decimal-16-2",
              width: ColumnWidth.Amount.width,
              label: () => {
                return `Amount (${this.BaseCurrency})`;
              },
              allowSorting: true,
              showInColumnChooser: true,
              visible: true,
              allowSearch: false,
            },
            {
              screenField: "Customer",
              filterDataField: "CustomerCode",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 8,
            },
            {
              screenField: "Supplier",
              filterDataField: "SupplierCode",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 9,
            },
          ],
          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            openFilterByDefault: true,
            expand: false,
            review: true,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                visible: true,
                buttonLocation: "left",
                clickAction: () => {
                  this.visibleGcSundryTransactionPopup();
                },
              },
            ],
          },
          valueChangedEventListners: [],
        },
      };
    },
    IsForeignCurrencyAccount() {
      return this.dataModel.CurrencyCode !== this.BaseCurrency;
    },
  },
  methods: {
    setrefreshDataGrid() {
      this.refreshDataGrid = true;
    },
    async checkReconciledRecords() {
      if (this.reconciledRecordIndices.length == 0) return;
      var dataGrid =
        this.$refs[
          "bank-reconciliation"
        ].$refs.transactionGrid.getGridInstance();

      var ids = [...this.reconciledRecordIndices];

      this.reconciledRecordIndices = [];

      setTimeout(() => {
        dataGrid.selectRowsByIndexes(ids);
      }, 500);
    },
    onRowSelectCallBack(data) {
      this.reconciledRecordIndices = [];
      if (data.length !== 0) {
        this.dataModel.FXReconciledPayments = 0;
        this.dataModel.FXReconciledReceipts = 0;
        this.dataModel.FXOutstandingPaymentTotal =
          this.dataModel.ApiFXOutstandingPaymentTotal;
        this.dataModel.FXOutstandingReceiptTotal =
          this.dataModel.ApiFXOutstandingReceiptTotal;

        data.forEach((element) => {
          this.recordCheckBoxChecked(element);
        });
        this.selectedGridItems = data;
      } else {
        this.selectedGridItems.forEach((element) => {
          this.recordCheckBoxUnChecked(element);
        });
        data = this.selectedGridItems;
        this.selectedGridItems = [];
        this.dataModel.FXReconciledPayments = 0;
        this.dataModel.FXReconciledReceipts = 0;
      }
    },
    calculateFXVarience(value) {
      this.dataModel.FXVarience = (
        this.dataModel.FXAccountBalance - value
      ).roundNumber(2);
    },
    setVarianceStyle(style) {
      this.varianceStyle = style;
    },
    async initialized() {
      this.setLoading = true;
      this.reload = false;

      await BankAccountsServices.getDetailsListData({
        filter: `Code eq '${this.baseView.id}'`,
        orderby: "TransactionDate asc",
      })
        .then((res) => {
          this.reconciliationDetailRecords = res.data.value;

          this.reconciliationDetailRecords.forEach((element, i) => {
            element.ID = element.RefNo;
            element.TransactionDate = new Date(element.TransactionDate);
            element.DateCreated = new Date(element.DateCreated);
            element.IsDraft === "YES"
              ? this.reconciledRecordIndices.push(i)
              : (element.IsDraft = "NO");

            if (element.IsDraft === "YES") {
              this.BankBookReconciliationFXStatementBalance =
                element.BankBookReconciliationFXStatementBalance;
              this.BankBookReconciliationStatementDate =
                element.BankBookReconciliationStatementDate;
            }
          });

          // this.checkReconciledRecords(index);
          // this.onRowSelectCallBack(this.selectedGridItems);
        })

        .catch((err) => {
          if (err) this.setLoading = false;
        });

      if (getDefaultUserSettings().CurrencyCode)
        this.BaseCurrency = getDefaultUserSettings().CurrencyCode;
      else this.BaseCurrency = "AUD";

      let {
        data: {
          value: [bankRecord],
        },
      } = await BankAccountsServices.getBankRecordByCode(this.baseView.id);

      if (bankRecord.FriendlyStatus == "Uncommitted Reconciliation") {
        this.dataModel.FXStatementBalance =
          this.BankBookReconciliationFXStatementBalance;
        this.dataModel.StatementDate = this.BankBookReconciliationStatementDate;
      }

      this.dataModel.CurrencyCode = bankRecord.CurrencyCode;
      this.dataModel.ExchangeRate = bankRecord.ExchangeRate;
      this.dataModel.BankAccountCode = bankRecord.Code;
      this.dataModel.AccountName = bankRecord.AccountName;
      this.dataModel.Status = bankRecord.FriendlyStatus;
      this.dataModel.BSBNO = bankRecord.BsbNo;
      this.dataModel.BankBranch = bankRecord.BankBranch;
      this.dataModel.AccountNo = bankRecord.AccountNo;
      this.dataModel.BookBalance = bankRecord.BookBalance;
      this.dataModel.FXBookBalance = bankRecord.FXBookBalance;
      this.dataModel.FXOutstandingPaymentTotal =
        bankRecord.FXOutstandingPaymentTotal;
      this.dataModel.FXOutstandingReceiptTotal =
        bankRecord.FXOutstandingReceiptTotal;
      // bankRecord.FXOutstandingReceiptTotal !== 0
      //   ? -Math.abs(bankRecord.FXOutstandingReceiptTotal)
      //   : 0;
      this.dataModel.FXAccountBalance = (
        bankRecord.FXBookBalance +
        bankRecord.FXOutstandingPaymentTotal -
        bankRecord.FXOutstandingReceiptTotal
      ).roundNumber(2);

      this.dataModel.FXVarience = (
        this.dataModel.FXAccountBalance - this.dataModel.FXStatementBalance
      ).roundNumber(2);

      this.dataModel.LastReconciledDate = bankRecord.LastReconciledDate;
      this.dataModel.LastReconciledAmount = bankRecord.LastReconciledAmount;

      this.dataModel.PaymentTotal = bankRecord.PaymentTotal;
      this.dataModel.ReceiptTotal = bankRecord.ReceiptTotal;
      this.dataModel.ApiFXBookBalance = bankRecord.FXBookBalance;
      this.dataModel.FXOpeningBalance = bankRecord.FXOpeningBalance;
      this.dataModel.ApiFXOutstandingPaymentTotal =
        bankRecord.FXOutstandingPaymentTotal;
      this.dataModel.ApiFXOutstandingReceiptTotal =
        bankRecord.FXOutstandingReceiptTotal;
      this.dataModel.CompanyBank = bankRecord.CompanyBank;
      this.dataModel.ExportCode = bankRecord.ExportCode;
      this.dataModel.ControlAccount = bankRecord.ControlAccount;
      this.dataModel.UserBank = bankRecord.UserBank;
      this.dataModel.AbaUserCode = bankRecord.AbaUserCode;
      this.dataModel.OpenningBalanceFiscalPeriod =
        bankRecord.OpenningBalanceFiscalPeriod;
      this.dataModel.OpenningBalanceFiscalYear =
        bankRecord.OpenningBalanceFiscalYear;
      // const {
      //   data: { value: tradingPartners },
      // } = await BankAccountsServices.getTradingPartners();
      // this.tradingPartners = tradingPartners.map(
      //   (tradingPartner) => tradingPartner.TradingPartner
      // );
      this.dataModel.Status = bankRecord.FriendlyStatus;
      this.reload = false;
      this.loaded = true;
      this.setLoading = false;
      this.refreshDataGrid = false;

      setTimeout(() => {
        if (this.selectedGridItems.length > 0) {
          this.$refs["bank-reconciliation"].$refs.transactionGrid.selectRows(
            this.selectedGridItems
          );
        }
      }, 100);
    },
    bankReconciliationDetailPostProcess(data) {
      data.forEach((element) => {
        element.TransactionDate = new Date(element.TransactionDate);
        element.DateCreated = new Date(element.DateCreated);
        element.CheckInclude = element.IsDraft == "NO" ? false : true;
      });
      this.updateHeaderCheckBox(data);
      return data;
    },
    visibleGcSundryTransactionPopup() {
      this.gcSundryTransactionPopupVisible = true;
    },
    updateHeaderFeild(field, value, operation) {
      let initialValue = this.dataModel[field];
      this.dataModel[field] = operation(initialValue, value);
    },
    addTwoValues(a, b) {
      let result = a + b;
      return result;
    },
    subtractValues(a, b) {
      let result = a - b;
      return result;
    },
    isHeaderField(type) {
      return type === "header";
    },
    gcSundryTransactionPopupCallBack() {
      this.gcSundryTransactionPopupVisible = false;
    },
    recordCheckBoxUnChecked(recordData) {
      // recordData.isSelected = false;

      if (
        recordData.TransactionType == "Sundry Payment" ||
        recordData.TransactionType == "Supplier Payment" ||
        recordData.TransactionType == "Cash Payment"
      ) {
        this.updateHeaderFeild(
          "FXOutstandingPaymentTotal",
          recordData.FXTransactionAmount,
          this.subtractValues // As all payment values are (-)ve, OutstandingPaymentTotal gets Added.
        );
        this.updateHeaderFeild(
          "FXReconciledPayments",
          recordData.FXTransactionAmount,
          this.subtractValues
        );
      } else {
        this.updateHeaderFeild(
          "FXOutstandingReceiptTotal",
          -recordData.FXTransactionAmount,
          this.subtractValues
        );
        this.updateHeaderFeild(
          "FXReconciledReceipts",
          recordData.FXTransactionAmount,
          this.subtractValues
        );
      }
      this.dataModel.FXAccountBalance = (
        this.dataModel.FXBookBalance +
        this.dataModel.FXOutstandingPaymentTotal - // / OutstandingReceiptTotal is a negative value
        this.dataModel.FXOutstandingReceiptTotal
      ).roundNumber(2);
      this.dataModel.FXVarience = (
        this.dataModel.FXAccountBalance - this.dataModel.FXStatementBalance
      ).roundNumber(2);
    },
    recordCheckBoxChecked(recordData) {
      // recordData.isSelected = true;
      if (
        recordData.TransactionType == "Sundry Payment" ||
        recordData.TransactionType == "Supplier Payment" ||
        recordData.TransactionType == "Cash Payment"
      ) {
        this.updateHeaderFeild(
          "FXOutstandingPaymentTotal",
          recordData.FXTransactionAmount,
          this.addTwoValues // As all payment values are (-)ve, OutstandingPaymentTotal gets reduced.
        );
        this.updateHeaderFeild(
          "FXReconciledPayments",
          -recordData.FXTransactionAmount,
          this.addTwoValues
        );
      } else {
        this.updateHeaderFeild(
          "FXOutstandingReceiptTotal",
          -recordData.FXTransactionAmount, // As OutstandingReceiptTotal is negative
          this.addTwoValues
        );
        this.updateHeaderFeild(
          "FXReconciledReceipts",
          recordData.FXTransactionAmount,
          this.addTwoValues
        );
      }
      this.dataModel.FXAccountBalance = (
        this.dataModel.FXBookBalance +
        this.dataModel.FXOutstandingPaymentTotal - // / OutstandingReceiptTotal is a negative value
        this.dataModel.FXOutstandingReceiptTotal
      ).roundNumber(2);
      this.dataModel.FXVarience = (
        this.dataModel.FXAccountBalance - this.dataModel.FXStatementBalance
      ).roundNumber(2);
    },
    updateHeaderCheckBox(gridItems) {
      var refHeadInstance =
        this.$refs["bank-reconciliation"].$refs["transactionGrid"].$refs[
          "cx-CheckInclude"
        ].getSeletcAllRef().instance;
      var checkBoxHeader = refHeadInstance.element();
      var getInstanceHeader = CheckBox.getInstance(checkBoxHeader);

      let count = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) count = count + 1;
      });

      setTimeout(() => {
        if (count > 0 && count != gridItems.length) {
          getInstanceHeader.option("value", undefined);
        } else if (count == 0) {
          getInstanceHeader.option("value", false);
        } else if (count == gridItems.length) {
          getInstanceHeader.option("value", true);
        }
      }, 100);
    },

    checkBoxValueChange({ value: isChecked }, { data: recordData, rowType }) {
      var gridItems = this.reconciliationDetailRecords; // component.getDataSource().items();
      if (isChecked === true) {
        // CheckBox Checked
        if (!this.isHeaderField(rowType)) {
          this.recordCheckBoxChecked(recordData);
          this.updateHeaderCheckBox(gridItems);
        } else {
          gridItems.forEach((gridItem) => {
            if (!gridItem.CheckInclude) {
              this.recordCheckBoxChecked(gridItem);
            }
          });

          this.$refs["bank-reconciliation"].$refs[
            "transactionGrid"
          ].updateOptions("dataSource", gridItems);

          this.updateHeaderCheckBox(gridItems);
        }
      } else if (isChecked === false) {
        // CheckBox UnChecked
        if (!this.isHeaderField(rowType)) {
          this.recordCheckBoxUnChecked(recordData);
          this.updateHeaderCheckBox(gridItems);
        } else {
          gridItems.forEach((gridItem) => {
            if (gridItem.CheckInclude) {
              this.recordCheckBoxUnChecked(gridItem);
            }
          });
        }
      }
      this.dataModel.Status =
        this.dataModel.FXAccountBalance === 0 ? "Reconciled" : "Unpresented";
    },
    async saveBankReconciliation(data) {
      if (this.selectedGridItems.length === 0) {
        this.$alert(
          "Please include one or more entries before attempting to save",
          "Error"
        );
        return;
      }

      if (this.dataModel.SaveAs == "C") {
        if (data.FXVarience !== 0) {
          this.$alert(
            "The Statement Balance you are attempting to commit does not match the calculated Account Balance. Please review the reconciled items and ensure that there is no variance before proceeding to commit this reconciliation",
            "Error"
          );
          return;
        }
      }

      const isConfirm = await this.$confirm(
        this.dataModel.SaveAs != "C"
          ? "You are about to save this Bank Reconciliation without committing. You will be able to retrieve this reconciliation and make further changes. Do you wish to proceed?"
          : "You are about to commit this Bank Reconciliation and you will not be able to make further changes. Do you wish to proceed?",
        "Confirmation"
      );
      if (isConfirm) {
        var FXCalculatedCashbookReceipts = 0;
        var FXCalculatedCashbookPayments = 0;
        this.selectedGridItems.forEach((gridItem) => {
          if (gridItem.IsDraft == "Yes") {
            FXCalculatedCashbookReceipts += gridItem.FXTransactionAmount;
            FXCalculatedCashbookPayments += gridItem.FXTransactionAmount;
          }
        });

        const payload = {
          BankBookHeader: {
            BankAccountCode: data.BankAccountCode,
            BankStatementDate: new Date(data.StatementDate).toSaveDate(),
            FXBankStatementBalance: data.FXStatementBalance,
            LastReconciledDate: data.LastReconciledDate,
            LastReconciledAmount: data.LastReconciledAmount,
            TotalPayments: data.PaymentTotal,
            TotalReceipts: data.ReceiptTotal,
            FXBankBookBalance: data.FXBookBalance,
            FXOpeningBankBookBalance: data.FXOpeningBalance,
            FXTotalOutstandingPayments: data.FXOutstandingPaymentTotal,
            FXTotalOutstandingReceipts: Math.abs(
              data.FXOutstandingReceiptTotal
            ),
            BankName: data.CompanyBank,
            BankBranch: data.BankBranch,
            BSBNo: data.BSBNO,
            BankAccountName: data.AccountName,
            BankAccountNo: data.AccountNo,
            GcorpBankFileExportCode: data.ExportCode,
            GLControlAccount: data.ControlAccount,
            ABABankId: data.UserBank,
            ABAUserCode: data.AbaUserCode,
            OpeningBalanceFiscalPeriod: data.OpenningBalanceFiscalPeriod,
            OpeningBalanceFiscalYear: data.OpenningBalanceFiscalYear,
            FXCalculatedCashbookReceipts: FXCalculatedCashbookReceipts,
            FXCalculatedCashbookPayments: FXCalculatedCashbookPayments,
            FXAccountBalance: data.FXAccountBalance,
            Difference: data.FXVarience,
            CommitReconciliation: this.dataModel.SaveAs == "C",
          },
          BankBookTransactionCollection: [],
        };
        this.selectedGridItems.forEach((gridItem) => {
          const BankBookTransaction = {
            AccountPeriod: gridItem.AccountPeriod,
            BankAccountCode: data.BankAccountCode,
            CashBookNo: gridItem.RefNo,
            Inactive: gridItem.Inactive,
            // IsCommitted: gridItem.IsCommitted,
            IsCommitted: true,
            Status: gridItem.Status,
            TotalRowCount: 0,
            FXTransactionAmount: gridItem.FXTransactionAmount,
            TransactionChequeNo: gridItem.TransactionChequeNo,
            TransactionComment: gridItem.TransactionPartner,
            TransactionDate: gridItem.TransactionDate,
            TransactionMethod: gridItem.TransactionMethod,
            TransactionNo: gridItem.TransactionNo,
            TransactionType: gridItem.TransactionType,
          };
          payload.BankBookTransactionCollection.push(BankBookTransaction);
        });

        await BankAccountTransactionServices.saveBankReconciliation(
          payload
        ).then((res) => {
          if (res) {
            this.$notify(`Bank Reconciliation Successful`, "success");
            this.setIgnoreRouteChangeConfirmation();
            if (this.baseView.query.from === "bank-account-list") {
              this.$router.push({
                path: `/bank-accounts`,
              });
            } else {
              this.$router.push({
                path: `/bank-accounts-transaction/review/${this.baseView.id}`,
              });
            }
          }
        });
      }
    },
  },
};
</script>
